import { environment } from '../../../../environments/environment';

export function storageFactory() {
  if (environment.mobile) {
    return localStorage;
  }

  return sessionStorage;
}
